import { IApplicationState } from '../../types/redux';

export function getBuildersList(state: IApplicationState) {
  const { buildersList } = state;

  if (buildersList?.constructorsList.length) {
    return buildersList.constructorsList;
  }

  return null;
}
